<template>
  <div class="content bg8">

    <div class="explore-programs-dropdown" style="text-align:center;padding:24px 16px 18px 16px;background:#fff;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
      <label for="program-select" class="dropdown-label" style="font-weight:600;color:#7a4fa3;font-size:1.1rem;margin-bottom:10px;display:block;">Explore Internship Programs</label>
      <select id="program-select" class="program-select" @change="onProgramChange" :value="$route.path">
        <option value="/digital-marketing-internship">Digital Marketing</option>
        <option value="/social-media-marketing-internship">Social Media Marketing</option>
        <option value="/content-creation-internship">Content Creation and Copywriting</option>
        <option value="/website-design-internship">Website Design</option>
        <option value="/data-analytics-internship">Data Analytics and BI</option>
        <option value="/graphic-design-internship">Graphic Design</option>
      </select>
    </div>

      <div class="middled">
        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      <div class="basehero">
        <h1>Digital Marketing Internship Program</h1>
        <h2 class="section">Real-World Experience for Students. Real Results for Startups.</h2>
        <p>
          At Foclarity, we bridge the gap between raw talent and real-world business needs. Our Digital Marketing Internship Program connects ambitious students with innovative startups that need smart, scrappy marketing help—<em>right now.</em>
        </p>
        <p>
          Interns get more than just a line on their resume. They gain hands-on experience working directly with startup founders, contributing to campaigns that make an actual impact. Startups get access to a team of bright, driven interns ready to dive in and deliver results.
        </p>
        <hr>
        <h3>For Startups:</h3>
        <strong>Your Agile, Affordable Growth Team</strong>
        <p>
          Early-stage companies don’t always have the time or budget to build a full marketing team. That’s where we come in.
        </p>
        <ul>
          <li>A vetted team of marketing interns matched to your startup’s needs</li>
          <li>Fresh thinking and creative execution from students trained in modern tools and tactics</li>
          <li>Oversight and support from experienced marketers to ensure quality and momentum</li>
          <li>Weekly updates, performance tracking, and campaign reports so you’re always in the loop</li>
        </ul>
        <p>You bring the vision—we’ll bring the team to help get it out into the world.</p>
        <hr>
        <h3>For Interns:</h3>
        <strong>Learn by Doing. Build by Creating.</strong>
        <p>
          Skip the coffee runs and shadowing. At Foclarity, you’ll work in teams to support real startups with real stakes. This is where marketing theory meets messy, beautiful execution.
        </p>
        <ul>
          <li>Experience in SEO, paid ads, email marketing, social media, and content strategy</li>
          <li>Exposure to marketing platforms like Google Analytics, HubSpot, Canva, and more</li>
          <li>Mentorship from professionals who’ve been in the trenches</li>
          <li>A portfolio of work to showcase to future employers</li>
          <li>Confidence and clarity about what kind of marketer you want to become</li>
        </ul>
        <blockquote style="margin: 24px 20%; font-style: italic; color: #7a4fa3; border-left: 4px solid #BF00FF; padding-left: 16px;">
          “Foclarity gave me the kind of experience I couldn’t find in a classroom. I left with skills, confidence, and a job offer.”<br>
          <span style="font-size: 0.95em; color: #41037b;">— Former Intern</span>
        </blockquote>
        <hr>
        <h3>What You’ll Work On</h3>
        <ul>
          <li>Campaign planning and execution</li>
          <li>SEO, SEM, and performance analytics</li>
          <li>Email marketing and automation tools</li>
          <li>Content creation for blogs, newsletters, and social media</li>
          <li>Brand storytelling and visual marketing</li>
          <li>Weekly strategy meetings and real-time collaboration</li>
        </ul>
        <hr>
        <h3>How It Works</h3>
        <ol>
          <li><strong>Apply</strong>: Whether you're a startup or a student, fill out our short application form.</li>
          <li><strong>Match</strong>: We match interns with startups based on interests, skills, and goals.</li>
          <li><strong>Launch</strong>: You’ll hit the ground running with a kickoff call and campaign roadmap.</li>
          <li><strong>Grow</strong>: Track progress, adapt strategies, and build momentum—together.</li>
        </ol>
        <hr>
        <h3>Ready to Join?</h3>
        <p>
          Whether you're a founder looking for help or a student ready to dive into digital marketing, this is your launchpad.
        </p>
        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      </div>
      <div class="explore-programs" style="text-align:center;padding:32px 16px 24px 16px;background:#f7f2fa;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <h2 style="color:#7a4fa3;font-size:1.3rem;margin-bottom:16px;">Explore More Internship Programs</h2>
        <ul class="explore-list" style="list-style:none;padding:0;margin:0;">
          <li style="margin:10px 0;"><router-link to="/digital-marketing-internship" class="subnav-link">Digital Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/social-media-marketing-internship" class="subnav-link">Social Media Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/content-creation-internship" class="subnav-link">Content Creation and Copywriting</router-link></li>
          <li style="margin:10px 0;"><router-link to="/website-design-internship" class="subnav-link">Website Design</router-link></li>
          <li style="margin:10px 0;"><router-link to="/data-analytics-internship" class="subnav-link">Data Analytics and BI</router-link></li>
          <li style="margin:10px 0;"><router-link to="/graphic-design-internship" class="subnav-link">Graphic Design</router-link></li>
        </ul>
        <div style="margin-top:18px;">
          <router-link to="/who-we-serve" class="subnav-link" style="font-size:1.05em;">Back to All Programs</router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "DigitalMarketingInternship",
  methods: {
    onProgramChange(event) {
      const path = event.target.value;
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.subnav-link {
  margin: 0 10px;
  color: #BF00FF;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.subnav-link:hover {
  color: #7a4fa3;
  text-decoration: underline;
}
.subnav-link.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.button-row {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
}
.button-row a {
  display: inline-block;
}
.explore-programs-dropdown {
  margin: 40px auto 0 auto;
  max-width: 600px;
  text-align: center;
  padding: 24px 16px 18px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(191,0,255,0.04);
}
.dropdown-label {
  font-weight: 600;
  color: #7a4fa3;
  font-size: 1.1rem;
  margin-bottom: 10px;
  display: block;
}
.program-select {
  width: 100%;
  max-width: 420px;
  padding: 12px 16px;
  font-size: 1.08rem;
  border: 1.5px solid #BF00FF;
  border-radius: 8px;
  background: #f7f2fa;
  color: #41037b;
  font-weight: 500;
  outline: none;
  transition: border 0.2s;
  margin: 0 auto;
  box-shadow: 0 1px 4px 0 rgba(122,79,163,0.04);
}
.program-select:focus {
  border: 2px solid #7a4fa3;
}
@media (max-width: 600px) {
  .button-row {
    flex-direction: column;
    gap: 8px;
  }
  .explore-programs-dropdown {
    padding: 16px 4px 12px 4px;
  }
  .program-select {
    font-size: 1em;
    padding: 10px 8px;
    max-width: 100%;
  }
}
</style>
